import React from 'react';
import { products } from '../mock/mockData';
import { ProductCard } from './USFlags';

const StateFlags = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-white py-12 border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold text-slate-900 mb-4">State Flags</h1>
            <p className="text-xl text-slate-600">
              Show your state pride with our high-quality state flags. All 50 states available in multiple sizes.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.stateFlags.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StateFlags;